import React from 'react';
import { useLanguage } from '../../i18n/LanguageContext';
import './case-studies.css';

const CaseStudies = () => {
  const { t } = useLanguage();
  return (
    <section className="case-studies-area section-padding" id="work">
      <div className="container">
        <div className="case-studies-header">
          <span className="section-label">{t.caseStudies?.label}</span>
          <h2 className="case-studies-heading">{t.caseStudies?.title}</h2>
        </div>
        <div className="case-studies-grid">
          {(t.caseStudies?.items ?? []).map((item) => (
            <div className="case-study-card" key={item.id}>
              <span className="industry-tag">{item.industry}</span>
              <h3>{item.title}</h3>
              <p className="summary">{item.summary}</p>
              <p className="result-line">{item.result}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
